module.exports = __webpack_public_path__ + "img/10f4342ccd28419e40f9deaa51a81d84.60b5660a.png";